// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { InfoOutlined, LightbulbOutlined } from '@mui/icons-material';
// type
import { NavItemType } from '../types/menu';
import { useMemo } from 'react';
import { DeepReadonly } from '../types/DeepReadonly';

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const useManagementMenuItems = (): DeepReadonly<NavItemType> =>
	useMemo(
		() => ({
			id: 'management',
			type: 'group',
			children: [
				{
					id: 'opportunities',
					title: <FormattedMessage id={'menu.opportunities'} />,
					type: 'item',
					url: '/opportunities',
					icon: InfoOutlined,
					isActive: (location) => location.pathname.startsWith('/opportunities'),
				},
				{
					id: 'actions',
					title: <FormattedMessage id={'menu.actions'} />,
					type: 'item',
					url: '/actions',
					icon: LightbulbOutlined,
					isActive: (location) => location.pathname.startsWith('/actions'),
				},
				//TODO: Uncomment when Competence will be ready
				/* {
			id: 'competence',
			title: <FormattedMessage id={'menu.competence'} />,
			type: 'item',
			url: '/competence',
			icon: LabelOutlined,
		}, */
			],
		}),
		[],
	);

export { useManagementMenuItems };
